export const META_TYPE = 'battery';
export const META_VER = 'v1';

export const CMD_BATTERY_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
